module.exports = __webpack_public_path__ + "resource/img/borrow.83bff69b.png";